<pdq-card variant="flat" color="white">
  <pdq-expandable-section id="multi-shipment-add-recipient-modal" [cacheState]="true" [initialCollapsed]="false">
    <div sectionHeader class="section-heading">
      <pdq-heading element="h6">Recipient modal</pdq-heading>
    </div>

    <div class="add-recipient-modal" [formGroup]="formGroup">
      <div class="field">
        <div class="title-row">
          <pdq-input
            label="Title when adding a recipient"
            formControlName="addRecipientTitle"
            [placeholder]="'Recipient {number}'"
            [mentionVariables]="numberOnlyVariables"
            [invalid]="formGroup.controls.addRecipientTitle.dirty && formGroup.controls.addRecipientTitle.invalid"
            invalidMsg="Modal title is required"></pdq-input>
          <pdq-input
            label="Title when editing a recipient"
            formControlName="editRecipientTitle"
            [placeholder]="'Edit {name}'"
            [mentionVariables]="titleVariables"
            [invalid]="formGroup.controls.editRecipientTitle.dirty && formGroup.controls.editRecipientTitle.invalid"
            invalidMsg="Modal title is required"></pdq-input>
        </div>
        <div class="title-row">
          <pdq-input
            label="Title when adding a gift note"
            formControlName="addGiftNoteTitle"
            [placeholder]="'Gift note {number}'"
            [mentionVariables]="numberOnlyVariables"
            [invalid]="formGroup.controls.addGiftNoteTitle.dirty && formGroup.controls.addGiftNoteTitle.invalid"
            invalidMsg="Modal title is required"></pdq-input>
          <pdq-input
            label="Title when editing a gift note"
            formControlName="editGiftNoteTitle"
            [placeholder]="'Edit gift note for {name}'"
            [mentionVariables]="titleVariables"
            [invalid]="formGroup.controls.editGiftNoteTitle.dirty && formGroup.controls.editGiftNoteTitle.invalid"
            invalidMsg="Modal title is required"></pdq-input>
        </div>
        <p class="body-12-regular hint">{{ '{number}' }} becomes 1, 2, 3 etc.</p>
      </div>

      <pdq-expandable-section
        class="step"
        id="multi-shipment-modal-step-items"
        formGroupName="items"
        [cacheState]="true"
        [divider]="false"
        [animate]="false"
        [nested]="true">
        <div sectionHeader class="step__label">
          <pdq-tag variant="primary" size="small" mode="rect">STEP 1</pdq-tag>
          <span class="body-14-medium">Items</span>
        </div>

        <div class="step__fields">
          <pdq-input
            label="Title"
            formControlName="title"
            placeholder="Which items for this recipient?"
            [invalid]="formGroup.controls.items.controls.title.dirty && formGroup.controls.items.controls.title.invalid"
            invalidMsg="Title is required"></pdq-input>
          <div class="field">
            <p class="body-14-medium">Description</p>
            <rich-textarea
              [initialContent]="formGroup.controls.items.controls.description.value"
              (contentChange)="onStepDescriptionChange(formGroup.controls.items.controls.description, $event)"
              placeholder="Use + and – to assign quantities. Items fully assigned to other recipients are greyed out."
              [invalid]="
                formGroup.controls.items.controls.description.dirty &&
                formGroup.controls.items.controls.description.invalid
              "
              errorMsg="Description is required"></rich-textarea>
          </div>
        </div>
      </pdq-expandable-section>

      <pdq-expandable-section
        class="step"
        id="multi-shipment-modal-step-address"
        formGroupName="address"
        [cacheState]="true"
        [divider]="false"
        [animate]="false"
        [nested]="true">
        <div sectionHeader class="step__label">
          <pdq-tag variant="primary" size="small" mode="rect">STEP 2</pdq-tag>
          <span class="body-14-medium">Address</span>
        </div>

        <div class="step__fields">
          <pdq-input
            label="Title"
            formControlName="title"
            placeholder="Where should this gift go?"
            [invalid]="
              formGroup.controls.address.controls.title.dirty && formGroup.controls.address.controls.title.invalid
            "
            invalidMsg="Title is required"></pdq-input>
          <div class="field">
            <p class="body-14-medium">Description</p>
            <rich-textarea
              [initialContent]="formGroup.controls.address.controls.description.value"
              (contentChange)="onStepDescriptionChange(formGroup.controls.address.controls.description, $event)"
              placeholder="Enter the recipient's address. We'll calculate shipping and tax for this destination."
              [invalid]="
                formGroup.controls.address.controls.description.dirty &&
                formGroup.controls.address.controls.description.invalid
              "
              errorMsg="Description is required"></rich-textarea>
          </div>
        </div>
      </pdq-expandable-section>

      <pdq-expandable-section
        class="step"
        id="multi-shipment-modal-step-shipping"
        formGroupName="shipping"
        [cacheState]="true"
        [divider]="false"
        [animate]="false"
        [nested]="true">
        <div sectionHeader class="step__label">
          <pdq-tag variant="primary" size="small" mode="rect">STEP 3</pdq-tag>
          <span class="body-14-medium">Shipping</span>
        </div>

        <div class="step__fields">
          <pdq-input
            label="Title"
            formControlName="title"
            placeholder="Select shipping method"
            [invalid]="
              formGroup.controls.shipping.controls.title.dirty && formGroup.controls.shipping.controls.title.invalid
            "
            invalidMsg="Title is required"></pdq-input>
          <div class="field">
            <p class="body-14-medium">Description</p>
            <rich-textarea
              [initialContent]="formGroup.controls.shipping.controls.description.value"
              (contentChange)="onStepDescriptionChange(formGroup.controls.shipping.controls.description, $event)"
              placeholder="Pick a delivery date inside a shipping option."></rich-textarea>
          </div>
          <div class="field" formGroupName="noRates">
            <pdq-input
              label="Banner when no rates are available"
              formControlName="title"
              placeholder="Shipping not available"
              [invalid]="noRatesTitleControl.dirty && noRatesTitleControl.invalid"
              invalidMsg="Title is required"></pdq-input>
            <rich-textarea
              [initialContent]="noRatesBodyControl.value"
              (contentChange)="onStepDescriptionChange(noRatesBodyControl, $event)"
              placeholder="Your order cannot be shipped to the selected address and delivery date."></rich-textarea>
          </div>
        </div>
      </pdq-expandable-section>

      <pdq-expandable-section
        class="step"
        id="multi-shipment-modal-step-giftNote"
        formGroupName="giftNote"
        [cacheState]="true"
        [divider]="false"
        [animate]="false"
        [nested]="true">
        <div sectionHeader class="step__label">
          <pdq-tag variant="primary" size="small" mode="rect">STEP 4</pdq-tag>
          <span class="body-14-medium">Gift note</span>
        </div>

        <div class="step__fields">
          <pdq-input
            label="Title"
            formControlName="title"
            placeholder="Add a gift note (optional)"
            [invalid]="
              formGroup.controls.giftNote.controls.title.dirty && formGroup.controls.giftNote.controls.title.invalid
            "
            invalidMsg="Title is required"></pdq-input>
          <div class="field">
            <p class="body-14-medium">Description</p>
            <rich-textarea
              [initialContent]="formGroup.controls.giftNote.controls.description.value"
              (contentChange)="onStepDescriptionChange(formGroup.controls.giftNote.controls.description, $event)"
              placeholder="We'll handwrite this on a gift card tucked inside the package."
              [invalid]="
                formGroup.controls.giftNote.controls.description.dirty &&
                formGroup.controls.giftNote.controls.description.invalid
              "
              errorMsg="Description is required"></rich-textarea>
          </div>
          <pdq-input-arrows
            label="Message character limit"
            [control]="messageLimitControl"
            [min]="1"
            [step]="10"
            widthSize="fullwidth"></pdq-input-arrows>
        </div>
      </pdq-expandable-section>
    </div>
  </pdq-expandable-section>
</pdq-card>
